import React from 'react';

const numberFmt = (n) => (n === 0 || n ? Number(n).toFixed(2) : '0.00');

const BalancesTable = ({ items, loading, onRowClick }) => {
  // Filtrer les clients avec solde total != 0
  const filteredItems = items.filter(row => {
    const soldeFinal = (row.ancienSolde || 0) + (row.solde750 || 0) + (row.perteCumulee || 0);
    return Math.abs(soldeFinal) > 0.001; // Tolérance pour erreurs d'arrondi
  });

  return (
    <div style={{ backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.12)', overflow: 'hidden' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
        <thead>
          <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
            <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 500, color: '#5f6368' }}>Client</th>
            <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 500, color: '#5f6368' }}>Ancien solde</th>
            <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 500, color: '#5f6368' }}>Entrées 750</th>
            <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 500, color: '#5f6368' }}>Sorties 750</th>
            <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 500, color: '#5f6368' }}>Perte</th>
            <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 500, color: '#5f6368' }}>Solde 750</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr><td colSpan={6} style={{ padding: '24px', textAlign: 'center', color: '#5f6368' }}>Chargement...</td></tr>
          )}
          {!loading && filteredItems.length === 0 && (
            <tr><td colSpan={6} style={{ padding: '24px', textAlign: 'center', color: '#5f6368' }}>Aucune donnée</td></tr>
          )}
          {!loading && filteredItems.map((row, idx) => {
            const soldeFinal = (row.ancienSolde || 0) + (row.solde750 || 0) + (row.perteCumulee || 0);
            return (
              <tr key={row.clientId} 
                  style={{ borderBottom: '1px solid #f0f0f0', transition: 'background 0.2s', cursor: 'pointer' }} 
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                  onClick={() => onRowClick && onRowClick(row)}>
                <td style={{ padding: '12px 16px', color: '#202124' }}>{row.clientName}</td>
                <td style={{ padding: '12px 16px', textAlign: 'right', color: '#5f6368' }}>{numberFmt(row.ancienSolde || 0)}</td>
                <td style={{ padding: '12px 16px', textAlign: 'right', color: '#34a853', fontWeight: 500 }}>{numberFmt(row.totalEntrees)}</td>
                <td style={{ padding: '12px 16px', textAlign: 'right', color: '#ea4335', fontWeight: 500 }}>{numberFmt(row.totalSorties)}</td>
                <td style={{ padding: '12px 16px', textAlign: 'right', color: '#fbbc04' }}>{numberFmt(row.perteCumulee)}</td>
                <td style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 600, color: soldeFinal >= 0 ? '#1a73e8' : '#ea4335' }}>{numberFmt(soldeFinal)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BalancesTable;
